let showPageTransition = localStorage.getItem('internalTransition');
let htmlEl = document.getElementsByTagName('html')[0];

if (showPageTransition === 'false' || showPageTransition == null || showPageTransition == undefined || showPageTransition == '') {
  function checkForBody() {
    if (htmlEl != undefined) {
      htmlEl.classList.add("noTransition", "startAnimations");
    } else {
      setTimeout(() => {
        checkForBody();
      }, 10);
    }
  }
  checkForBody();
} 
else {
    window.addEventListener("DOMContentLoaded", (event) => {
        setTimeout(function() {
        htmlEl.classList.add("fadeout","startAnimations");
        localStorage.setItem("internalTransition", false);
        }, 350);
    });
}